import React from 'react';
import { useNavigate } from 'react-router-dom';
import holder from '../../assets/img/metamask-icon.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Button } from 'components/Button/Button';
import { AnchorText } from 'components/AnchorText/AnchorText';
import './MetamaskLogin.scss';
import { useUser } from '../../hooks/useUser';
import { routes } from '../../routing/routes';

const MetamaskLogin = () => {
  const { account, ethereum } = useUser();
  const navigate = useNavigate();

  return (
    <div className="metamask-container mt-3 p-3">
      <div className="row mx-sm-0 mx-1 justify-content-center">
        <h2 className="text-center mb-2 mt-2">Connect Wallet</h2>
        <p className="text-center">Please connect your MetaMask wallet to proceed.</p>

        <hr className="separator" />

        <div className="metamask-icon mb-4">
          <LazyLoadImage src={holder} alt="Register" className="img-fluid" />
        </div>

        <div className="mb-3">
          <Button
            primary
            fullWidth
            onClick={() => {
              ethereum.login(account?.dusktech?.userId ?? null);
              navigate(routes.loginDusktech());
            }}
          >
            Connect Wallet
          </Button>
        </div>
        <p className="form-footer">
          Don’t have a wallet?
          <AnchorText href={routes.login()}>Create one here</AnchorText>
        </p>
      </div>
    </div>
  );
};

export default MetamaskLogin;
